import { type FC, useEffect } from 'react';

import { useAddFundsListener } from '@/common/hooks/add-funds-listener';
import { useBackButtonNavigation } from '@/common/hooks/back-button';
import { useEarnRewardLogEvents } from '@/common/hooks/earnReward-logEvents';
import { useEnergyRecovery } from '@/common/hooks/energy-recovery';
import { useHapticFeedback } from '@/common/hooks/haptic-feedback';
import { useLotteryWinnersListener } from '@/common/hooks/lottery-winners-listener';
import { useNavigateToErrorPage } from '@/common/hooks/navigate-to-error-page';
import { useBindTonWallet } from '@/common/hooks/onBindTonWallet';
import { useOpenContractPlusListener } from '@/common/hooks/open-contract-plus-listener';
import { useTimerToNextSell } from '@/common/hooks/timer-to-next-sell';
import { useUserLevelUpListener } from '@/common/hooks/user-level-up-listener';
import { useVipStatusHandler } from '@/common/hooks/vip-status-handler';
import {
  playBackgroundMusic,
  stopBackgroundMusic,
} from '@/common/lib/soundEffect';

const InitHooksProvider: FC = () => {
  useUserLevelUpListener();
  useBackButtonNavigation();
  useEnergyRecovery();
  useAddFundsListener();
  useOpenContractPlusListener();
  useLotteryWinnersListener();
  useHapticFeedback();
  useEarnRewardLogEvents();
  useNavigateToErrorPage();
  useBindTonWallet();
  useTimerToNextSell();
  useVipStatusHandler();

  useEffect(() => {
    playBackgroundMusic('main_music');

    return (): void => {
      stopBackgroundMusic();
    };
  }, []);

  return null;
};

export { InitHooksProvider };
